import styled from 'styled-components';

export const Name = styled.a`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 14px;
  font-weight: 600;
  width: max-content;
`;
